module.exports = "/_next/static/images/instrument_2-3246673c206e28712ed4b78cf7fdc0fd.png";